import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DirectusService, EvaluationCriteria} from '@frontend/directus';
import {
  CriteriaWeightingResponse,
  EvaluationComparisonControllerService,
  EvaluationCriteriaControllerService,
  EvaluationCriteriaResponse,
  EvaluationCriteriaWeightingControllerService,
  PairwiseComparisonRequest,
  PairwiseComparisonsResponse,
  ProjectChapterType,
  ProjectStepType,
  UpsertCriteriaWeightingRequest,
} from '@frontend/shared-api';

@Injectable({providedIn: 'root'})
export class Step41EvaluationCriteriaXService {
  private readonly directusService = inject(DirectusService);
  private readonly criteriaController = inject(EvaluationCriteriaControllerService);
  private readonly comparisonController = inject(EvaluationComparisonControllerService);
  private readonly weightingController = inject(EvaluationCriteriaWeightingControllerService);

  loadCriteria(projectId: number): Observable<EvaluationCriteriaResponse[]> {
    return this.criteriaController
      .getEvaluationCriteriaByProject({projectId})
      .pipe(map((criteria) => [...criteria].sort((a, b) => a.ecNumber - b.ecNumber)));
  }

  loadDirectusCriteria(): Observable<EvaluationCriteria[]> {
    return this.directusService.loadEvaluationCriteria();
  }

  loadComparisons(projectId: number): Observable<PairwiseComparisonsResponse> {
    return this.comparisonController.getEvaluationCriteriaComparisons({projectId});
  }

  saveComparisons(
    projectId: number,
    comparisons: PairwiseComparisonRequest[],
  ): Observable<PairwiseComparisonsResponse> {
    return this.comparisonController.setEvaluationCriteriaComparisons({
      projectId,
      setPairwiseComparisonsRequest: {
        comparisons,
        chapterTitle: ProjectChapterType.EVALUATION_CRITERIA,
        stepTitle: ProjectStepType.EVALUATION_CRITERIA,
      },
    });
  }

  loadWeighting(projectId: number): Observable<CriteriaWeightingResponse> {
    return this.weightingController.getEvaluationCriteriaWeighting({projectId});
  }

  saveWeighting(
    projectId: number,
    request: UpsertCriteriaWeightingRequest,
  ): Observable<CriteriaWeightingResponse> {
    return this.weightingController.upsertEvaluationCriteriaWeighting({
      projectId,
      upsertCriteriaWeightingRequest: request,
    });
  }
}
